/** Development-only trace. Production builds do not print these messages. */
export function devLog(...args) {
  if (import.meta.env.DEV) {
    console.log(...args);
  }
}
